import { render, staticRenderFns } from "./share-icon.vue?vue&type=template&id=aef94410&scoped=true&"
import script from "./share-icon.vue?vue&type=script&lang=ts&"
export * from "./share-icon.vue?vue&type=script&lang=ts&"
import style0 from "./share-icon.vue?vue&type=style&index=0&id=aef94410&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef94410",
  null
  
)

export default component.exports